(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("borderless-dark", [], factory);
	else if(typeof exports === 'object')
		exports["borderless-dark"] = factory();
	else
		root["SurveyTheme"] = root["SurveyTheme"] || {}, root["SurveyTheme"]["BorderlessDark"] = factory();
})(this, () => {
return 